export function makePriceIncrease(roundPrices, percentIncrease, increaseOn) {
  return {
    roundPrices,
    percentIncrease,
    increaseOn
  };
}